// GoogleTrack.ts

import Util from "@/Master/Util";
import {confJson} from "@/app/config/confJson";
import TagManager from 'react-gtm-module';

/**
 * GoogleTrack.ts
 *
 * 一个用于初始化和管理 Google Analytics 和 Google Tag Manager 的跟踪工具类。
 */
export default class GoogleTrack {
    private static readonly tag: string = `[KitTrack]`;

    /**
     * 初始化 KitTrack SDK，包括 Google Analytics 和 Google Tag Manager。
     */
    static InitSdk(): void {
        if (Util.isLog) {
            console.log(this.tag, `Init KitTrack SDK`);
        }
        // 初始化 Google Tag Manager
        this.InitGTM();
    }

    /**
     * 初始化 Google Tag Manager。
     */
    private static InitGTM(): void {
        if (!confJson.GTM_ID) {
            console.warn(`${this.tag} GTM_ID 未配置`);
            return;
        }

        TagManager.initialize({
            gtmId: confJson.GTM_ID, // 替换为你的 GTM 容器 ID
        });

        if (Util.isLog) {
            console.log(this.tag, `Init GTM ID=${confJson.GTM_ID}`);
        }
    }

    /**
     * 向 Google Tag Manager 推送自定义事件。
     * @param eventName - 事件名称
     * @param eventData - 事件自定义参数
     */
    static pushGTMEvent<T extends Record<string, any>>(eventName: string, eventData: T): void {
        try {
            const tagManagerArgs = {
                dataLayer: {
                    ...eventData
                },
                dataLayerName: eventName
            }
            TagManager.dataLayer(tagManagerArgs)
            if (Util.isLog) {
                console.log(`${this.tag} 推送 GTM 事件:`, tagManagerArgs);
            }
        } catch (error) {
            if (Util.isLog) {
                console.error(`${this.tag} 推送 GTM 事件失败:`, error);
            }
        }
    }
}
